<template>
    <generic-page>
        <b-btn
            variant="link"
            size="lg"
            class="pl-0"
            :to="`/creator/creatorVideo/edit/${creatorVideoId}`"
        >
            <font-awesome-icon size="lg" icon="fa-light fa-chevron-left" />
            Back to Video
        </b-btn>

        <h5>
            <font-awesome-icon
                icon="fa-duotone fa-thumbs-up"
                class="text-primary mr-1"
            />
            Upvotes
        </h5>
        <div class="text-secondary small mb-3">
            Customers who upvoted your video
        </div>

        <div class="py-2">
            <div v-if="loading">
                <generic-loading />
            </div>
            <div v-else-if="upvotes && upvotes.length">
                <div
                    :key="upvote.standardMap.id"
                    v-for="upvote in upvotes"
                    @click="viewProfile(upvote.standardMap)"
                >
                    <user-standard-avatar
                        :standardMap="upvote.standardMap"
                        :nonPrimaryPhotos="false"
                        :hideBadges="true"
                        size="small"
                        class="border-light border-top"
                    />
                </div>
            </div>
            <div v-else class="text-center text-secondary py-4">
                No upvotes yet
            </div>
        </div>

        <generic-pagination
            @next="next"
            @previous="previous"
            :hasMorePages="hasMorePages"
            :page="page"
        />
    </generic-page>
</template>

<script>
import GenericPagination from "@/components/utility/GenericPagination";
import UserStandardAvatar from "@/components/user/UserStandardAvatar";

export default {
    data() {
        return {
            page: 1,
            hasMorePages: false,
            upvotes: null,
            loading: false,
        };
    },
    computed: {
        creatorVideoId() {
            return this.$route.params?.id;
        },
    },
    created() {
        this.refresh();
    },
    methods: {
        viewProfile(standardMap) {
            this.$store.dispatch("profile/viewProfile", {
                userId: standardMap.id,
                profile: standardMap,
            });
        },
        next() {
            this.page++;
            this.refresh();
        },
        previous() {
            this.page--;
            this.refresh();
        },
        refresh() {
            this.loading = true;

            this.api
                .post(`/creatorVideo/${this.creatorVideoId}/upvotes`, {
                    page: this.page,
                })
                .then((response) => {
                    this.upvotes = response?.data?.upvotes;
                    this.hasMorePages = response?.data?.hasMorePages;
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    components: {
        GenericPagination,
        UserStandardAvatar,
    },
};
</script>
